import React, { Component } from 'react';
import { Card, CardActions, Switch } from 'react-md';

import './ToggleAnimation.scss';

class ToggleAnimation extends Component {
  render() {
    const self = this;
    return (
      <div className="togani-container md-grid mobile-fix">
        <Card className="md-block-centered">
          <CardActions>
            <Switch
              id="animation-switch"
              key="animation-switch"
              label="Globe rotation"
              name="animation-switch"
              defaultChecked
              onChange={function (checked) {
                self.props.handleToggleAnimation(checked);
              }}
            />
          </CardActions>
        </Card>
      </div>
    );
  }
}

export default ToggleAnimation;



// WEBPACK FOOTER //
// ./src/components/ToggleAnimation/ToggleAnimation.jsx